<template>
    <header>
      <h1>Физические эксперименты</h1>
      <nav>
        <router-link to="/" class="menu">главная</router-link>
        <router-link to="/эксперименты" class="menu">эксперименты</router-link>
        <router-link to="/квесты" class="menu">квесты</router-link>
        <router-link to="/3д" class="menu">3д модели</router-link>
      </nav>
    </header>
  </template>
  
  <script>
  export default {
    name: 'HeaderComponent',
  };
  </script>
  
  <style >
  .menu{
    color: #00c7eb;
    padding: 2%;
  }
  </style>